var render = function render(){var _vm=this,_c=_vm._self._c;return _c('res-select',{attrs:{"id":_vm.elementId,"items":_vm.bases,"attach":_vm.attachId,"loading":_vm.loading,"readonly":_vm.readonly,"placeholder":"All Bases","return-object":""},model:{value:(_vm.selectedBasis),callback:function ($$v) {_vm.selectedBasis=$$v},expression:"selectedBasis"}})
}
var staticRenderFns = []

export { render, staticRenderFns }